import { render, staticRenderFns } from "./PasswordModal.vue?vue&type=template&id=10686b72&"
import script from "./PasswordModal.vue?vue&type=script&lang=js&"
export * from "./PasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10686b72')) {
      api.createRecord('10686b72', component.options)
    } else {
      api.reload('10686b72', component.options)
    }
    module.hot.accept("./PasswordModal.vue?vue&type=template&id=10686b72&", function () {
      api.rerender('10686b72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/basedata/modules/PasswordModal.vue"
export default component.exports